import React from 'react';
import { withTranslation } from 'react-i18next';
import { Modal, Button, Input, message, Tag } from 'antd';
import { InputContainer, InputLabel, ModalTagContainer } from '../../components/Modals/styles';
import REGEX from "../../utils/regex";
import { SEND_TEST_EMAIL_MODAL, SEND_EMAIL_MODAL } from '../../components/Modals/translationValues';

const NAMESPACES = ['SEND_TEST_EMAIL_MODAL', 'SEND_EMAIL_MODAL'];

class SendTestEmailModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      addresses: [],
      inputVisible: true,
      inputValue: '',
      editInputIndex: -1,
      editInputValue: '',
      borderVisibility: false,
      defaultSmtp: true,
      password: ''
    };
    this.passwordRef = React.createRef(null);
  }

  handleClose = removedTag => {
    const addresses = this.state.addresses.filter(tag => tag !== removedTag);
    this.setState({ addresses });
  };

  handleInputChange = e => {
    this.setState({ inputValue: e.target.value, borderVisibility: true });
  };

  handleInputConfirm = () => {
    const { inputValue } = this.state;
    const { t } = this.props;
    let { addresses } = this.state;
    let trimedTag = inputValue.trim().replace(/\s/g, '');
    if (trimedTag.length > 0) {
      const isValidEmail = REGEX.EMAIL.test(trimedTag);
      if (!isValidEmail) {
        message.error(t(SEND_TEST_EMAIL_MODAL.INVALID_EMAIL_ERROR_MESSAGE.key, SEND_TEST_EMAIL_MODAL.INVALID_EMAIL_ERROR_MESSAGE.value));
        return;
      }
      let exists = addresses.some(tag => tag.toLowerCase() === trimedTag.toLowerCase());
      if (!exists) {
        addresses.push(trimedTag);
      } else {
        message.error(t(SEND_EMAIL_MODAL.EMAIL_ALREADY_EXISTS_ERROR.key, SEND_EMAIL_MODAL.EMAIL_ALREADY_EXISTS_ERROR.value));
      }
    }
    this.setState({
      addresses,
      inputValue: '',
    });
  };

  saveInputRef = input => {
    this.input = input;
  };

  sendTestEmail = async () => {
    const { addresses, password } = this.state;
    if (addresses.length > 0) {
      const { sendTestEmail } = this.props;
      sendTestEmail(addresses, password);
    } else {
      message.error(this.props.t(
        `SEND_EMAIL_MODAL:${SEND_EMAIL_MODAL.EMPTY_ADD_RECIPIENTS_ERROR_MESSAGE.key}`,
        SEND_EMAIL_MODAL.EMPTY_ADD_RECIPIENTS_ERROR_MESSAGE.value
      ));
    }
  };

  handleInputFocus = () => {
    this.setState({
      borderVisibility: true,
    });
  };

  handleInputOutofFocus = () => {
    this.handleInputConfirm();
    this.setState({
      borderVisibility: false,
    });
  };

  defaultSMTPChange = e => {
    this.setState({ defaultSmtp: e.target.checked});
  };

  onChangePassword = (e) => {
    this.setState({
      password: e.target.value
    });
  }

  render() {
    const { t, onCancel, isLoading } = this.props;
    const { addresses, inputValue, borderVisibility } = this.state;
    return (
      <Modal
        width="600px"
        centered
        maskClosable={false}
        visible={true}
        onCancel={() => onCancel(false)}
        footer={[
          <Button key="back" onClick={() => onCancel(false)}>
            {t(SEND_TEST_EMAIL_MODAL.CANCEL_BUTTON.key, SEND_TEST_EMAIL_MODAL.CANCEL_BUTTON.value)}
          </Button>,
          <Button key="Send Mail" type="primary" loading={isLoading} onClick={this.sendTestEmail} disabled={this.props.showPassword && this.state.password === ''}>
            {isLoading
              ? t(
                `SEND_EMAIL_MODAL:${SEND_EMAIL_MODAL.SENDING_EMAIL_BUTTON_TEXT.key}`,
                SEND_EMAIL_MODAL.SENDING_EMAIL_BUTTON_TEXT.value
              )
              : t(
                `SEND_EMAIL_MODAL:${SEND_EMAIL_MODAL.SEND_EMAIL_BUTTON.key}`,
                SEND_EMAIL_MODAL.SEND_EMAIL_BUTTON.value
              )}
          </Button>,
        ]}
      >
        <InputLabel>
          {t(
            `SEND_EMAIL_MODAL:${SEND_EMAIL_MODAL.SEND_EMAIL_TO_LABEL.key}`,
            SEND_EMAIL_MODAL.SEND_EMAIL_TO_LABEL.value
          )}
        </InputLabel>
        <ModalTagContainer border={borderVisibility}>
          {addresses.map((emailAddress, index) => {
            return (
              <Tag
                className="edit-tag"
                key={emailAddress}
                closable={true}
                onClose={() => this.handleClose(emailAddress)}
                color="#df4c35"
              >
                <span title={emailAddress}>{emailAddress}</span>
              </Tag>
            );
          })}
          <InputContainer tagInput>
            <Input
              name="emailAddress"
              ref={this.saveInputRef}
              type="text"
              className="tag-input"
              value={inputValue}
              onFocus={this.handleInputFocus}
              onChange={this.handleInputChange}
              onBlur={this.handleInputOutofFocus}
              onPressEnter={this.handleInputConfirm}
              placeholder={t(SEND_TEST_EMAIL_MODAL.ADD_MAIL_ADDRESS_PLACEHOLDER.key, SEND_TEST_EMAIL_MODAL.ADD_MAIL_ADDRESS_PLACEHOLDER.value)}
              autoComplete={"off"}
            />
          </InputContainer>
        </ModalTagContainer>
        {this.props.showPassword && (
              <>
                <InputLabel style={{ marginTop: 5 }}>
                  {t(SEND_TEST_EMAIL_MODAL.ENTER_PASSWORD_LABEL.key, SEND_TEST_EMAIL_MODAL.ENTER_PASSWORD_LABEL.value)}
                </InputLabel>
                <InputContainer>
                    <Input
                      name="password"
                      ref={this.passwordRef}
                      type="text"
                      onChange={this.onChangePassword}
                      placeholder={t(SEND_TEST_EMAIL_MODAL.ENTER_PASSWORD_PLACEHOLDER.key, SEND_TEST_EMAIL_MODAL.ENTER_PASSWORD_PLACEHOLDER.value)}
                      autoComplete={"off"}
                     />
                </InputContainer>
              </>
        )}
      </Modal>
    );
  }
}
export default withTranslation(NAMESPACES)(SendTestEmailModal);